/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injectable} from './di';
export class Console {
/**
 * @param {?} message
 * @return {?}
 */
log(message: string): void {
    // tslint:disable-next-line:no-console
    console.log(message);
  }
/**
 * @param {?} message
 * @return {?}
 */
warn(message: string): void {
    // tslint:disable-next-line:no-console
    console.warn(message);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Console_tsickle_Closure_declarations() {
/** @type {?} */
Console.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Console.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/core/src/console.ts